import React, { FC } from 'react';

type Props = {
  className?: string;
};

export const Percent: FC<Props> = ({ className }) => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.3158 4.36768C1.23115 4.50086 0.509837 3.94562 0.385687 2.9345L0.369887 2.80582C0.245738 1.7947 0.811298 1.08146 1.89595 0.948277C2.9806 0.815099 3.69272 1.37147 3.81686 2.38258L3.83267 2.51127C3.95681 3.52238 3.40045 4.2345 2.3158 4.36768ZM2.20519 3.46687C2.52691 3.42737 2.75832 3.18435 2.69286 2.65122L2.67706 2.52253C2.6116 1.9894 2.32827 1.80959 2.00655 1.84909C1.67564 1.88972 1.44423 2.13273 1.50969 2.66587L1.52549 2.79455C1.59095 3.32769 1.87428 3.5075 2.20519 3.46687ZM7.23325 7.02957C6.1486 7.16275 5.42729 6.60751 5.30314 5.5964L5.28734 5.46771C5.16319 4.4566 5.72875 3.74335 6.8134 3.61017C7.89805 3.47699 8.61017 4.03336 8.73432 5.04447L8.75012 5.17316C8.87427 6.18428 8.3179 6.89639 7.23325 7.02957ZM7.12265 6.12876C7.44436 6.08926 7.67578 5.84624 7.61032 5.31311L7.59452 5.18442C7.52906 4.65129 7.24572 4.47148 6.92401 4.51098C6.5931 4.55161 6.36168 4.79463 6.42714 5.32776L6.44294 5.45645C6.5084 5.98958 6.79174 6.16939 7.12265 6.12876ZM2.45941 7.51309L5.52079 0.605837L6.66979 0.464759L3.6084 7.37201L2.45941 7.51309Z"
      fill="white"
    />
  </svg>
);
